<template>
	<div>
		<breadcrumb :routerList="[{to:'/cost/Detail',title:'费用管理'},{title:'详情'}]" />
		<div class="left">
			<div>
				<span class="xunjia">基本信息</span>
				<div class="zhongbiao">
					<div class="clear">
						<el-form :model="data" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
							<el-form-item label="费用编码" class="h-elformWrap-2">
								<el-input readonly v-model="data.costCode"></el-input>
							</el-form-item>
							<el-form-item label="使用类型" class="h-elformWrap-2">
								<el-input readonly v-model="data.usedType"></el-input>
							</el-form-item>
							<el-form-item label="分销渠道" class="h-elformWrap-2">
								<el-input readonly v-model="data.disChannels"></el-input>
							</el-form-item>
							<el-form-item label="费用金额" class="h-elformWrap-2">
								<el-input readonly v-model="data.costAmount"></el-input>
							</el-form-item>
							<el-form-item label="费用状态" class="h-elformWrap-2">
								<el-input readonly v-model="data.costState"></el-input>
							</el-form-item>
							<el-form-item label="创建时间" class="h-elformWrap-2">
								<el-input readonly v-model="data.cdate"></el-input>
							</el-form-item>
							<el-form-item label="发起人工号" class="h-elformWrap-2">
								<el-input readonly v-model="data.userCode"></el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
			<div>
				<span class="xunjia">特价信息</span>
				<div class="zhongbiao">
					<div class="clear">
						<el-form :model="data" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
							<el-form-item label="费用类型" class="h-elformWrap-2">
								<el-input readonly v-model="data.costType"></el-input>
							</el-form-item>
							<el-form-item label="特价版本" class="h-elformWrap-2">
								<el-input readonly v-model="data.specialVersion"></el-input>
							</el-form-item>
							<el-form-item label="特价型号" class="h-elformWrap-2">
								<el-input readonly v-model="data.specialVersion"></el-input>
							</el-form-item>
							<el-form-item label="单型号费用" class="h-elformWrap-2">
								<el-input readonly v-model="data.costAmount"></el-input>
							</el-form-item>
							<el-form-item label="特价数量" class="h-elformWrap-2">
								<el-input readonly value="30"></el-input>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</div>
		</div>
		<div class="enter">
			<el-row>
				<el-button class="h-btn h-bBtn h-bgblueQ2" @click="returnTable">返回</el-button>
			</el-row>
		</div>
	</div>
</template>
<script>
   import ss from '../../../api/SystemService'
	export default {
		data() {
			return {
				data:{
					costCode:'',
					usedType:'',
					disChannels:'',
					costAmount:'',
					costState:'',
					cdate:'',
					userCode:'',
					costType:'',
					specialVersion:'',
				},
				radio: '',
				formLabelAlign: {
					name: '',
					contact: '',
					contactInfo: '',
					type: '',
					date3: '',
					explain: ''
				},
				form: {
					name: '',
					region: '',
					date1: '',
					date2: '',
					delivery: false,
					type: [],
					resource: '',
					desc: ''
				}
			}
		},
		//加载页面默认执行
		created() {
			//默认首次取数
			this.getTableEls();
		},
		methods: {
			returnTable() {
				console.log("我才运行了");
				this.$router.push({path: "/cost/BscCostDetail"});
			},
			getTableEls(){
				//拿到id
				this.idMsg = this.$router.history.current.query.id;
				var id ={
					id: this.idMsg,
				}
				//取页面参数
				ss.costDetailService.getCostDetailById(id).then(rd => {
					this.data.costCode = rd.costCode;
					this.data.usedType = rd.usedType==1?'占用':rd.usedType==2?'释放':'';
					//this.data.usedType = rd.usedType;
					this.data.disChannels = rd.disChannels==1?'内销':rd.disChannels==2?'外销':rd.disChannels==3?'上海直销':'';
					//this.data.disChannels = rd.disChannels;
					this.data.costAmount = rd.costAmount;
					this.data.costState = rd.costState; //==0?'已取消':rd.costState==1?'预占用':rd.costState==2?'已转化':'';
					this.data.cdate = rd.cdate;
					this.data.userCode = rd.userCode;
					this.data.costType = rd.costType==1?'工程特价':rd.costType==2?'订单特价':'';
					//this.data.costType = rd.costType;
					this.data.specialVersion = rd.specialVersion;
				})
			},
			onSubmit() {
				// console.log('submit!');
			}
		}
	}
</script>
<style scoped>
	.clear::after {
		content: '';
		display: block;
		width: 0;
		height: 0;
		clear: both;
	}
	.left {
		background-color: rgb(255, 255, 255);
		padding: 20px;
		margin: 20px;
		border: 1px solid #E2E2E2;
	}
	.xunjia {
		color: #0e75e9;
		display: inline-block;
		padding-left: 10px;
		border-left: 5px solid #0e75e9;
		font-weight: bold;
		font-size: 0.18rem;
		margin-bottom: 30px;
	}
	.zhongbiao {
		margin-left: 20px;
		overflow: hidden;
	}
	.enter {
	    text-align: center;
	}
</style>
<style>
	.clear .h-formbLine .el-form-item__label {
		width: 29%;
	}
	.clear .h-formbLine .el-form-item__content {
		width: 71%;
	}
	.clear .h-formbLine .h-elformWrap-2{
		width: 33.33%;
	}
</style>
